var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-0 pa-0",staticStyle:{"overflow":"hidden"},attrs:{"height":"calc(100vh - 100px)"}},[_c('WindowFrame',{ref:"windowframe_magazzino",staticClass:"ma-0 pa-0",attrs:{"referrerpolicy":"origin","component":'magazzino',"input_args":_vm.input_args},on:{"click_chiudi":_vm.gotoDashboard,"loaded":_vm.sendParamsMag}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }